<template>
  <div class="px-4 py-4 text-white lg:px-32 bg-dark-type-1">
    <div class="flex items-center justify-between">
      <div class="flex items-center justify-between w-full py-2">
        <div class="flex-grow flex-shrink-0 lg:flex-grow-0">
          <router-link to="/">
            <img src="@/assets/img/logo.svg" alt="Shuttlers" />
          </router-link>
        </div>
        <div class="items-center hidden lg:flex">
          <div>
            <router-link
              to="/dashboard/charter"
              v-slot="{ href, isExactActive, navigate }"
            >
              <a
                :href="href"
                @click="navigate"
                class="px-8 py-3 text-sm font-bold rounded"
                :class="isExactActive ? 'bg-gray-type-1' : 'bg-active'"
                >Charter</a
              >
            </router-link>
            <router-link
              to="/dashboard/home"
              class="ml-8 text-sm font-bold nav-link"
              >Home</router-link
            >
            <router-link
              to="/dashboard/my-bookings"
              class="ml-8 text-sm font-bold nav-link"
              >My bookings</router-link
            >
            <router-link
              to="/dashboard/wallet"
              class="ml-8 text-sm font-bold nav-link"
              >My wallet</router-link
            >
            <router-link
              to="/dashboard/account"
              class="ml-8 text-sm font-bold nav-link"
              v-if="isIframeMode"
              >My account</router-link
            >
          </div>
          <router-link
            to="/dashboard/notifications"
            class="relative ml-8 text-sm font-bold"
          >
            <svg viewBox="0 0 20 20" fill="currentColor" class="w-6 h-6 bell">
              <path
                d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"
              />
            </svg>
            <span
              class="
                absolute
                top-0
                right-0
                w-2
                h-2
                mr-1
                bg-green-300
                rounded-full
                bg-active-blue
              "
              v-if="unreadNotificationsCount > 0"
            ></span>
          </router-link>
          <dropdown
            placement="bottom-start"
            class="inline-block ml-10"
            v-if="!isIframeMode"
          >
            <div class="relative flex items-center">
              <div>
                <img
                  :src="user.avatar"
                  v-if="user && user.avatar"
                  class="object-cover w-8 h-8 rounded-full"
                />
                <svg
                  v-else
                  width="32"
                  height="32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g fill-rule="nonzero" fill="none">
                    <circle fill="#D1D6D4" cx="16" cy="15.909" r="15.646" />
                    <path
                      d="M21.714 14.251V11.68a5.714 5.714 0 00-2.88-4.994 5.714 5.714 0 00-5.714 0 5.714 5.714 0 00-2.834 4.994v2.571c-.001 1.806.962 3.475 2.525 4.378a6.48 6.48 0 006.469 0 5.051 5.051 0 002.434-4.378z"
                      fill="#F3F7F5"
                    />
                    <path
                      d="M16 31.543a15.589 15.589 0 0010.766-4.309 12.571 12.571 0 00-21.532 0A15.589 15.589 0 0016 31.543z"
                      fill="#F3F7F5"
                    />
                  </g>
                </svg>
              </div>
              <div class="ml-3 text-left" v-if="user">
                <div class="text-sm font-bold">
                  {{ user.fname }} {{ user.lname }}
                </div>
                <div class="font-medium text-xxs text-label">
                  {{ user.email }}
                </div>
              </div>
              <div v-else class="flex flex-col">
                <shimmer
                  width="100px"
                  height="10px"
                  class="block lg:ml-2"
                ></shimmer>
                <shimmer
                  width="50px"
                  height="10px"
                  class="block mt-1 lg:ml-2"
                ></shimmer>
              </div>
              <svg
                class="w-6 h-6 ml-6 text-white fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
            <div
              slot="dropdown"
              class="
                w-48
                px-3
                py-4
                mt-2
                ml-10
                text-left
                bg-white
                rounded
                text-dark-type-4
              "
              style="box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1)"
            >
              <span
                class="
                  absolute
                  top-0
                  right-0
                  block
                  w-4
                  h-4
                  mr-4
                  transform
                  rotate-45
                  translate-y-1
                  bg-white
                  rounded
                "
              ></span>
              <router-link to="/dashboard/account" class="text-xs font-medium"
                >My account</router-link
              >
              <div
                class="mt-6 text-xs font-medium"
                style="color: #fc7171"
                @click="logout"
              >
                Logout
              </div>
            </div>
          </dropdown>
        </div>
      </div>
      <div class="block lg:hidden">
        <button
          @click="open = true"
          type="button"
          class="
            inline-flex
            items-center
            justify-center
            p-2
            text-gray-400
            transition
            duration-150
            ease-in-out
            rounded-md
            hover:text-gray-500
            hover:bg-gray-100
            focus:outline-none
            focus:bg-gray-100
            focus:text-gray-500
          "
        >
          <svg
            class="w-6 h-6"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>
      <transition
        enter-class="duration-150 ease-out"
        enter-active-class="scale-95 opacity-0"
        enter-to-class="scale-100 opacity-100"
        leave-class="duration-100 ease-in"
        leave-active-class="scale-100 opacity-100"
        leave-to-class="scale-95 opacity-0"
      >
        <div
          v-if="open"
          class="
            absolute
            inset-x-0
            top-0
            z-40
            p-2
            transition
            origin-top-right
            transform
            md:hidden
          "
        >
          <div class="rounded-lg shadow-md">
            <div
              class="
                pb-4
                overflow-hidden
                text-white
                rounded-lg
                shadow-xs
                bg-dark-type-1
              "
            >
              <div class="flex items-center justify-between px-5 pt-4">
                <router-link to="/">
                  <img src="@/assets/img/logo.svg" alt="Shuttlers" />
                </router-link>
                <div class="-mr-2">
                  <button
                    @click="open = false"
                    type="button"
                    class="
                      inline-flex
                      items-center
                      justify-center
                      p-2
                      text-gray-400
                      transition
                      duration-150
                      ease-in-out
                      rounded-md
                      hover:text-gray-500
                      hover:bg-gray-100
                      focus:outline-none
                      focus:bg-gray-100
                      focus:text-gray-500
                    "
                  >
                    <svg
                      class="w-6 h-6"
                      stroke="currentColor"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <div class="flex flex-col mt-5 space-y-5">
                <router-link
                  to="/dashboard/charter"
                  v-slot="{ href, isExactActive, navigate }"
                >
                  <a
                    :href="href"
                    @click="navigate"
                    class="px-8 text-sm font-bold rounded"
                    :class="isExactActive ? 'text-gray-type-1' : 'text-active'"
                    >Charter</a
                  >
                </router-link>
                <router-link
                  to="/dashboard"
                  active-class="active"
                  class="px-8 text-sm font-bold"
                  >Home</router-link
                >
                <router-link
                  to="/dashboard/my-bookings"
                  class="px-8 text-sm font-bold"
                  >My bookings</router-link
                >
                <router-link
                  to="/dashboard/wallet"
                  class="px-8 text-sm font-bold"
                  >My wallet</router-link
                >
                <router-link
                  to="/dashboard/notifications"
                  class="px-8 text-sm font-bold"
                  >My notifications</router-link
                >
                <router-link
                  to="/dashboard/account"
                  class="
                    relative
                    flex
                    items-center
                    px-8
                    pt-4
                    mt-2
                    border-t border-gray-700
                  "
                >
                  <div>
                    <img
                      :src="user.avatar"
                      v-if="user && user.avatar"
                      class="object-cover w-8 h-8 rounded-full"
                    />
                    <svg
                      v-else
                      width="32"
                      height="32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill-rule="nonzero" fill="none">
                        <circle fill="#D1D6D4" cx="16" cy="15.909" r="15.646" />
                        <path
                          d="M21.714 14.251V11.68a5.714 5.714 0 00-2.88-4.994 5.714 5.714 0 00-5.714 0 5.714 5.714 0 00-2.834 4.994v2.571c-.001 1.806.962 3.475 2.525 4.378a6.48 6.48 0 006.469 0 5.051 5.051 0 002.434-4.378z"
                          fill="#F3F7F5"
                        />
                        <path
                          d="M16 31.543a15.589 15.589 0 0010.766-4.309 12.571 12.571 0 00-21.532 0A15.589 15.589 0 0016 31.543z"
                          fill="#F3F7F5"
                        />
                      </g>
                    </svg>
                  </div>
                  <div class="ml-3 text-left" v-if="user">
                    <div class="text-sm font-bold">
                      {{ user.fname }} {{ user.lname }}
                    </div>
                    <div class="font-medium text-xxs text-label">
                      {{ user.email }}
                    </div>
                  </div>
                  <div v-else class="flex flex-col">
                    <shimmer
                      width="100px"
                      height="10px"
                      class="block lg:ml-2"
                    ></shimmer>
                    <shimmer
                      width="50px"
                      height="10px"
                      class="block mt-1 lg:ml-2"
                    ></shimmer>
                  </div>
                </router-link>
              </div>
              <div class="flex items-center justify-center mt-4">
                <div
                  class="
                    mt-6
                    text-xs
                    font-medium
                    text-green-300 text-active-blue
                  "
                  @click="logout"
                >
                  Logout
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Shimmer from "./Shimmer";
import { mapGetters } from "vuex";
import Dropdown from "@/components/Dropdown";

export default {
  components: {
    Dropdown,
    Shimmer,
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("app", ["unreadNotificationsCount"]),
    isIframeMode() {
      return process.env.VUE_APP_APP_MODE == "iframe";
    },
  },
  watch: {
    $route() {
      this.open = false;
    },
  },
  methods: {
    async logout() {
      this.$store.dispatch("auth/logout").then(() => {
        this.$store.dispatch("resetStates");

        this.$router.push({ name: "home" });
      });
    },
  },
};
</script>